import { AfterViewInit, Directive, ElementRef, OnInit, Optional, Renderer2 } from '@angular/core';
import { ButtonComponent } from '../../button/button.component';
import { download } from '../download';
import { LoaderService } from '../../progress/loader.service';

@Directive({
  selector: 'a[mtgDownload],mtg-button[mtgDownload]'
})
export class DownloadDirective implements AfterViewInit {
  constructor(
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private loaderService: LoaderService,
    @Optional() private buttonComponent: ButtonComponent,
  ) {
  }

  ngAfterViewInit() {
    if (this.buttonComponent) {
      this.renderer.listen(this.buttonComponent.linkElement.nativeElement, 'click', this.onClick.bind(this));
    } else {
      this.renderer.listen(this.elementRef.nativeElement, 'click', this.onClick.bind(this));
    }
  }

  private async onClick(event): Promise<void> {
    event.preventDefault();
    const href = this.buttonComponent
      ? this.buttonComponent.href
      : this.elementRef.nativeElement.getAttribute('href');
    this.loaderService.show();
    try {
      await download(href);
    } finally {
      this.loaderService.hide();
    }
  }
}
